import { cmsApi } from '../../services/cmsApi';

export interface WidgetId {
    _id: string;
    name: string;
    script_url: string;
    widget_type: string;
    description: string;
    category: string;
    image: string;
}

export interface Widget {
    _id: string;
    name: string;
    description?: string;
    preview_image: string;
    html_url: string;
    widget_id: WidgetId;
    rss_feed_url?: string;
    live_app_url?: string;
    file_type: string;
    background_color?: string;
    text_color?: string;
    font_family?: string;
    font_style?: string;
    scroll_speed?: string;
    alignment?: string;
    font_weight?: string;
    createdAt: string;
    updatedAt: string;
    width?: number;
    height?: number;
}

export interface GetWidgetsResponse {
    results: Widget[];
    page: number;
    limit: number;
    totalPages: number;
    totalResults: number;
}

export interface GetWidgetsRequest {
    page?: number;
    limit?: number;
    search?: string;
}

export const widgetsApi = cmsApi.injectEndpoints({
    endpoints: (builder) => ({
        getMyWidgets: builder.query<GetWidgetsResponse, GetWidgetsRequest | void>({
            query: (params) => {
                const queryParams: any = { ...params };
                if (!queryParams.search) delete queryParams.search;
                return {
                    url: '/externalApp/v1/my-widgets',
                    method: 'GET',
                    params: queryParams,
                };
            },
            // Key the cache by search query so that different searches don't merge
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return `${endpointName}-${(queryArgs as GetWidgetsRequest)?.search || 'all'}`;
            },
            // Merge incoming results into the existing cache for infinite scroll
            merge: (currentCache, newItems) => {
                if (newItems.page === 1) {
                    return newItems;
                }
                currentCache.results.push(...newItems.results);
                currentCache.page = newItems.page;
                currentCache.totalPages = newItems.totalPages;
                currentCache.totalResults = newItems.totalResults;
            },
            // Always refetch when the page changes
            forceRefetch({ currentArg, previousArg }) {
                return currentArg !== previousArg;
            },
            providesTags: (result) =>
                result
                    ? [
                        ...result.results.map(({ _id }) => ({ type: 'Assets' as const, id: _id })),
                        { type: 'Assets', id: 'LIST' },
                    ]
                    : [{ type: 'Assets', id: 'LIST' }],
        }),
    }),
});

export const { useGetMyWidgetsQuery } = widgetsApi;
